module.exports = __webpack_public_path__ + "img/laptop.71635e08.svg";